export default __webpack_public_path__ + "static/media/logo.2706a06b.svg";